import prophylacticVaccinesIcon from "../assets/images/prophylactic-vaccines-icon.png";
import usaFlag from "../assets/images/usa-flag.svg";

export const contactusCardContent = [
    {
    title: 'Care Team Contact Us Card - US',
    headline: 'To place an order or for support',
    message: `1-866-MODERNA (1-866-663-3762)\n 8:00AM - 8:00PM, Monday - Friday\n WeCare@modernatx.com`,
    icon: {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: '2wQ7GSaGNr9QsirrrDwWrJ',
        type: 'Asset',
        createdAt: '2022-10-28T13:45:09.591Z',
        updatedAt: '2022-12-09T19:13:58.864Z',
        environment: {
            sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 11,
        revision: 2,
        locale: 'en-US'
        },
        fields: {
        title: 'Faq Category Icon',
        description: 'Faq Category SVG',
        file: {
            url: prophylacticVaccinesIcon,
            details: {
            size: 40893,
            image: {
                width: 600,
                height: 600
            }
            },
            fileName: 'Moderna_Icon_ProphylacticVaccines.png',
            contentType: 'image/png'
        }
        }
    },
    country: {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: '7sht7920U6vs3CLH2CUyaa',
        type: 'Entry',
        createdAt: '2023-05-18T03:23:50.744Z',
        updatedAt: '2023-05-24T22:55:23.250Z',
        environment: {
            sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 6,
        revision: 2,
        contentType: {
            sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'country'
            }
        },
        locale: 'en-US'
        },
        fields: {
        name: 'United States',
        isocode: 'US',
        flag: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '3aYCbZJiL8aoEKRdhjOXyy',
            type: 'Asset',
            createdAt: '2023-05-24T22:54:50.939Z',
            updatedAt: '2023-05-24T22:54:50.939Z',
            environment: {
                sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
            },
            fields: {
            title: 'usa flag',
            description: 'USA Flag',
            file: {
                url: usaFlag,
                details: {
                size: 2487,
                image: {
                    width: 36,
                    height: 26
                }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
            }
            }
        },
        locales: [
            'en-US'
        ]
        }
    }
    },
    {
    title: 'Report Adverse Event Contact Us Card - US',
    headline: 'Report an adverse event',
    message: `Click the arrow to submit an adverse event report`,
    icon: {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: '2wQ7GSaGNr9QsirrrDwWrJ',
        type: 'Asset',
        createdAt: '2022-10-28T13:45:09.591Z',
        updatedAt: '2022-12-09T19:13:58.864Z',
        environment: {
            sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 11,
        revision: 2,
        locale: 'en-US'
        },
        fields: {
        title: 'Faq Category Icon',
        description: 'Faq Category SVG',
        file: {
            url: prophylacticVaccinesIcon,
            details: {
            size: 40893,
            image: {
                width: 600,
                height: 600
            }
            },
            fileName: 'Moderna_Icon_ProphylacticVaccines.png',
            contentType: 'image/png'
        }
        }
    },
    link: {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: '6mzHEzPj12cIX1TCNBE7p2',
        type: 'Entry',
        createdAt: '2021-12-15T18:53:22.036Z',
        updatedAt: '2023-01-10T22:05:28.098Z',
        environment: {
            sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 7,
        revision: 2,
        contentType: {
            sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'externalLink'
            }
        },
        locale: 'en-US'
        },
        fields: {
        title: 'Get Help - Moderna Expert Link',
        label: 'Get Help - Moderna Expert ',
        url: 'https://report.moderna.convergehealthsafety.com/'
        }
    },
    country: {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: '7sht7920U6vs3CLH2CUyaa',
        type: 'Entry',
        createdAt: '2023-05-18T03:23:50.744Z',
        updatedAt: '2023-05-24T22:55:23.250Z',
        environment: {
            sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 6,
        revision: 2,
        contentType: {
            sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'country'
            }
        },
        locale: 'en-US'
        },
        fields: {
        name: 'United States',
        isocode: 'US',
        flag: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '3aYCbZJiL8aoEKRdhjOXyy',
            type: 'Asset',
            createdAt: '2023-05-24T22:54:50.939Z',
            updatedAt: '2023-05-24T22:54:50.939Z',
            environment: {
                sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
            },
            fields: {
            title: 'usa flag',
            description: 'USA Flag',
            file: {
                url: usaFlag,
                details: {
                size: 2487,
                image: {
                    width: 36,
                    height: 26
                }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
            }
            }
        },
        locales: [
            'en-US'
        ]
        }
    },
    label: 'Report an adverse event'
    },
    {
    title: 'FAQ Contact Us Card - US',
    headline: 'FAQs',
    message: `Frequently asked questions about Moderna Direct\n\n'`,
    icon: {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: '2wQ7GSaGNr9QsirrrDwWrJ',
        type: 'Asset',
        createdAt: '2022-10-28T13:45:09.591Z',
        updatedAt: '2022-12-09T19:13:58.864Z',
        environment: {
            sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 11,
        revision: 2,
        locale: 'en-US'
        },
        fields: {
        title: 'Faq Category Icon',
        description: 'Faq Category SVG',
        file: {
            url: prophylacticVaccinesIcon,
            details: {
            size: 40893,
            image: {
                width: 600,
                height: 600
            }
            },
            fileName: 'Moderna_Icon_ProphylacticVaccines.png',
            contentType: 'image/png'
        }
        }
    },
    link: {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: '4sGXFZd1qHOz98lelP3ptv',
        type: 'Entry',
        createdAt: '2022-10-25T05:36:49.166Z',
        updatedAt: '2023-09-11T17:49:57.795Z',
        environment: {
            sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 11,
        revision: 3,
        contentType: {
            sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'internalLink'
            }
        },
        locale: 'en-US'
        },
        fields: {
        title: 'FAQs Link',
        label: 'Frequently Asked Questions ',
        pageReference: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '16VVyRwgvsqxp7Q0GBqDwl',
            type: 'Entry',
            createdAt: '2022-10-26T23:39:27.943Z',
            updatedAt: '2022-10-26T23:39:27.943Z',
            environment: {
                sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 11,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'page'
                }
            },
            locale: 'en-US'
            },
            fields: {
            name: 'Main FAQ Page',
            title: 'Page Title from Compose',
            slug: 'faqs',
            seo: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '3mfYDCFlr6nPLagdXV7jo8',
                type: 'Entry',
                createdAt: '2022-10-26T23:39:28.038Z',
                updatedAt: '2022-10-26T23:39:28.038Z',
                environment: {
                    sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 26,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'seo'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'Main FAQ Page - Compose: SEO',
                title: 'Frequently Asked Questions Moderna',
                description: 'This page provides answers to frequently asked questions on Moderna Direct',
                no_index: false,
                no_follow: false
                }
            },
            content: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '1c7FRISzjyCWuduGT6H36O',
                type: 'Entry',
                createdAt: '2022-10-26T23:39:28.060Z',
                updatedAt: '2022-10-28T13:50:25.044Z',
                environment: {
                    sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'pageFaqsPageTemplate'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'Main FAQ Page - FAQs Page Template',
                faqModules: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '55Xgsw7Lb26fvzm4vznbe3',
                    type: 'Entry',
                    createdAt: '2022-10-26T23:39:28.125Z',
                    updatedAt: '2023-05-30T19:07:13.038Z',
                    environment: {
                        sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 24,
                    revision: 7,
                    contentType: {
                        sys: {
                        type: 'Link',
                        linkType: 'ContentType',
                        id: 'faqPage'
                        }
                    },
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'FAQs Page',
                    banner: {
                        metadata: {
                        tags: [],
                        concepts: []
                        },
                        sys: {
                        space: {
                            sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                            }
                        },
                        id: '7FSPIxBv2f8DUuOYNyjN2f',
                        type: 'Entry',
                        createdAt: '2022-10-25T05:36:06.733Z',
                        updatedAt: '2023-06-16T18:23:48.072Z',
                        environment: {
                            sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment'
                            }
                        },
                        publishedVersion: 21,
                        revision: 4,
                        contentType: {
                            sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'bannerComponent'
                            }
                        },
                        locale: 'en-US'
                        },
                        fields: {
                        title: 'FAQs',
                        headline: 'Browse answers to frequently asked questions',
                        backgroundImage: {
                            metadata: {
                            tags: [],
                            concepts: []
                            },
                            sys: {
                            space: {
                                sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                                }
                            },
                            id: '5zfGJA7or5WGcLdYi4Qde',
                            type: 'Asset',
                            createdAt: '2022-10-28T18:53:29.208Z',
                            updatedAt: '2022-10-28T18:53:29.208Z',
                            environment: {
                                sys: {
                                id: 'master',
                                type: 'Link',
                                linkType: 'Environment'
                                }
                            },
                            publishedVersion: 6,
                            revision: 1,
                            locale: 'en-US'
                            },
                            fields: {
                            title: 'Banner BG Strand Top',
                            description: '',
                            file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                                details: {
                                size: 47693,
                                image: {
                                    width: 1920,
                                    height: 511
                                }
                                },
                                fileName: 'Banner BG Strand Top .png',
                                contentType: 'image/png'
                            }
                            }
                        },
                        country: {
                            metadata: {
                            tags: [],
                            concepts: []
                            },
                            sys: {
                            space: {
                                sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                                }
                            },
                            id: '7sht7920U6vs3CLH2CUyaa',
                            type: 'Entry',
                            createdAt: '2023-05-18T03:23:50.744Z',
                            updatedAt: '2023-05-24T22:55:23.250Z',
                            environment: {
                                sys: {
                                id: 'master',
                                type: 'Link',
                                linkType: 'Environment'
                                }
                            },
                            publishedVersion: 6,
                            revision: 2,
                            contentType: {
                                sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'country'
                                }
                            },
                            locale: 'en-US'
                            },
                            fields: {
                            name: 'United States',
                            isocode: 'US',
                            flag: {
                                metadata: {
                                tags: [],
                                concepts: []
                                },
                                sys: {
                                space: {
                                    sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                    }
                                },
                                id: '3aYCbZJiL8aoEKRdhjOXyy',
                                type: 'Asset',
                                createdAt: '2023-05-24T22:54:50.939Z',
                                updatedAt: '2023-05-24T22:54:50.939Z',
                                environment: {
                                    sys: {
                                    id: 'master',
                                    type: 'Link',
                                    linkType: 'Environment'
                                    }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                locale: 'en-US'
                                },
                                fields: {
                                title: 'usa flag',
                                description: 'USA Flag',
                                file: {
                                    url: usaFlag,
                                    details: {
                                    size: 2487,
                                    image: {
                                        width: 36,
                                        height: 26
                                    }
                                    },
                                    fileName: 'usa_flag.svg',
                                    contentType: 'image/svg+xml'
                                }
                                }
                            },
                            locales: [
                                'en-US'
                            ]
                            }
                        }
                        }
                    },
                    contactUsCtaComponent: {
                        metadata: {
                        tags: [],
                        concepts: []
                        },
                        sys: {
                        space: {
                            sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                            }
                        },
                        id: '6gqCKf6EtK3mI0yNzKHx5h',
                        type: 'Entry',
                        createdAt: '2022-10-28T20:10:43.478Z',
                        updatedAt: '2022-10-31T05:40:26.928Z',
                        environment: {
                            sys: {
                            id: 'master',
                            type: 'Link',
                            linkType: 'Environment'
                            }
                        },
                        publishedVersion: 12,
                        revision: 3,
                        contentType: {
                            sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'contactUsCta'
                            }
                        },
                        locale: 'en-US'
                        },
                        fields: {
                        contactUsMessage: 'Still can\'t find what you are looking for?',
                        contactUsButtonLabel: 'CONTACT US',
                        contactUsLink: {
                            sys: {
                            type: 'Link',
                            linkType: 'Entry',
                            id: '4HqZvZWcCaClANwXQS032G'
                            }
                        },
                        backgroundImage: {
                            metadata: {
                            tags: [],
                            concepts: []
                            },
                            sys: {
                            space: {
                                sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                                }
                            },
                            id: '4udXXZnb6huWaP2x7gPRJO',
                            type: 'Asset',
                            createdAt: '2022-10-31T05:40:17.871Z',
                            updatedAt: '2022-10-31T05:40:17.871Z',
                            environment: {
                                sys: {
                                id: 'master',
                                type: 'Link',
                                linkType: 'Environment'
                                }
                            },
                            publishedVersion: 3,
                            revision: 1,
                            locale: 'en-US'
                            },
                            fields: {
                            title: 'Banner BG Strand Bottom',
                            description: '',
                            file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/4udXXZnb6huWaP2x7gPRJO/ac6296b15f97d71afaaa140bea8e323b/Banner_BG_Strand_Bottom.png',
                                details: {
                                size: 26282,
                                image: {
                                    width: 1920,
                                    height: 324
                                }
                                },
                                fileName: 'Banner BG Strand Bottom.png',
                                contentType: 'image/png'
                            }
                            }
                        }
                        }
                    }
                    }
                },
                faqCategoryIcon: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '2wQ7GSaGNr9QsirrrDwWrJ',
                    type: 'Asset',
                    createdAt: '2022-10-28T13:45:09.591Z',
                    updatedAt: '2022-12-09T19:13:58.864Z',
                    environment: {
                        sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 11,
                    revision: 2,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'Faq Category Icon',
                    description: 'Faq Category SVG',
                    file: {
                        url: prophylacticVaccinesIcon,
                        details: {
                        size: 40893,
                        image: {
                            width: 600,
                            height: 600
                        }
                        },
                        fileName: 'Moderna_Icon_ProphylacticVaccines.png',
                        contentType: 'image/png'
                    }
                    }
                }
                }
            }
            }
        }
        }
    },
    country: {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: '7sht7920U6vs3CLH2CUyaa',
        type: 'Entry',
        createdAt: '2023-05-18T03:23:50.744Z',
        updatedAt: '2023-05-24T22:55:23.250Z',
        environment: {
            sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 6,
        revision: 2,
        contentType: {
            sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'country'
            }
        },
        locale: 'en-US'
        },
        fields: {
        name: 'United States',
        isocode: 'US',
        flag: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '3aYCbZJiL8aoEKRdhjOXyy',
            type: 'Asset',
            createdAt: '2023-05-24T22:54:50.939Z',
            updatedAt: '2023-05-24T22:54:50.939Z',
            environment: {
                sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
            },
            fields: {
            title: 'usa flag',
            description: 'USA Flag',
            file: {
                url: usaFlag,
                details: {
                size: 2487,
                image: {
                    width: 36,
                    height: 26
                }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
            }
            }
        },
        locales: [
            'en-US'
        ]
        }
    },
    label: 'View Frequently Asked Questions'
    }
]